import { Destination } from './../../destination/destination.reducer';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../api/api.service';
import * as _ from 'lodash';
import store from './../../../store/store.module';
import { FETCH_DESTINATIONS_REQUESTED } from '../../destination/list/list.action';
import { CREATE_BULK_LOCATIONS_REQUESTED, CREATE_LOCATION_REQUESTED } from './create.action';
import {UtilityService} from "../../../common/services/utility/utility.service";

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent implements OnInit {

  public store = store;
  public locations = [];
  public location = {
    code: '',
    name: '',
    type: '',
    destination_id: ''
  };

  constructor(
    private api: ApiService,
    private router: Router,
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    store.dispatch({ type: FETCH_DESTINATIONS_REQUESTED });
    let redirectedData = this.utilityService.getRedirectData();
    this.location = _.assign(this.location, redirectedData ? (redirectedData.defaultValue ? redirectedData.defaultValue : {}) : {});
  }

  createLocations(): void {
    let data = _.assign({}, {
      type: 'Location',
      method: 'create',
      content: this.locations
    });
    store.dispatch({ type: CREATE_BULK_LOCATIONS_REQUESTED, data: data });
  }

  onSubmit(form): void {
    if (form.valid) {
      store.dispatch({ type: CREATE_LOCATION_REQUESTED, data: this.location, redirect: this.utilityService.getRedirectData().page });
    }
  }

  addRow(code, name, type, destination) {
    this.locations.push({
      code: code.value,
      name: name.value,
      type: type.value,
      destinationCode: destination.value
    });
  }

  removeRow(row) {
    _.remove(this.locations, item => item === row);
  }
}
